import { useToast } from '@chakra-ui/react';
import { isAxiosError } from 'axios';
import { isValidationError, isWellFormedApiError, isWellFormedGenericApiError, } from '../../services/errors/error';
import { localise } from '../../services/lang/lang';
import { getErrorText } from '../../services/errors/getErrorText';
import { apiErrorsToFormikErrors } from '../../services/errors/formErrors';
const useMutationErrorHandler = () => {
    const toast = useToast();
    const handleError = (error, helpers) => {
        if (isAxiosError(error)) {
            if (isWellFormedApiError(error)) {
                if (isValidationError(error)) {
                    helpers?.setErrors(apiErrorsToFormikErrors(error.response?.data?.errors));
                    return;
                }
                toast({
                    description: getErrorText(error),
                    status: 'error',
                    isClosable: true,
                });
                return;
            }
            if (isWellFormedGenericApiError(error)) {
                toast({
                    description: error.response?.data.message,
                    status: 'error',
                    isClosable: true,
                });
            }
        }
        toast({
            description: localise('UNKNOWN_ERROR_MESSAGE'),
            status: 'error',
            isClosable: true,
        });
    };
    return { handleError };
};
export default useMutationErrorHandler;
